/**
 * Enum for referencing animations
 */
import {
    animate,
    animation,
    keyframes,
    style,
    transition,
    trigger,
    useAnimation,
} from "@angular/animations"

/**
 * Slide animations
 */
export const slideInOut = trigger("slideInOut", [
    transition(":enter", [
        style({ transform: "translateY(-100%)" }),
        animate("350ms ease-in", style({ transform: "translateY(0%)" })),
    ]),
    transition(":leave", [animate("200ms ease-in", style({ transform: "translateY(-100%)" }))]),
])

/**
 * Bounce Animations
 */
export const bounce = trigger("bounce", [
    transition(
        "* => *",
        useAnimation(
            animation(
                [
                    style({ transform: "translate3d(0, 0, 0)" }),
                    animate(
                        "{{ timing }}s {{ delay }}s",
                        keyframes([
                            style({ transform: "translate3d(0, 0, 0)", offset: 0.2 }),
                            style({ transform: "translate3d(0, -30px, 0)", offset: 0.4 }),
                            style({ transform: "translate3d(0, 0, 0)", offset: 0.53 }),
                            style({ transform: "translate3d(0, -15px, 0)", offset: 0.7 }),
                            style({ transform: "translate3d(0, -4px, 0)", offset: 0.9 }),
                            style({ transform: "translate3d(0, 0, 0)", offset: 1 }),
                        ])
                    ),
                ],
                { params: { timing: 1, delay: 0 } }
            )
        )
    ),
])

/**
 * Fade animations
 */
export const fadeAnimation = trigger("fadeAnimation", [
    transition(":enter", [style({ opacity: 0 }), animate("2000ms", style({ opacity: 1 }))]),
])

/**
 * Zoom animations
 */

/**
 * Generic function for zoom effect
 */
const zoomInX = (a, b) => {
    return animation(
        animate(
            "{{ timing }}s {{ delay }}s cubic-bezier(0.550, 0.055, 0.675, 0.190)",
            keyframes([
                style({
                    opacity: 0,
                    transform: `scale3d(.1, .1, .1) translate3d({{ a }}, 0, 0)`,
                    offset: 0,
                }),
                style({
                    opacity: 1,
                    transform: `scale3d(.475, .475, .475) translate3d({{ b }}, 0, 0)`,
                    offset: 0.6,
                }),
            ])
        ),
        { params: { timing: 1, delay: 0, a, b } }
    )
}

export const zoomIn = trigger("zoomIn", [
    transition(
        "* => *",
        useAnimation(
            animation(
                [
                    animate(
                        "{{ timing }}s {{ delay }}s",
                        keyframes([
                            style({
                                opacity: 0,
                                transform: "scale3d(.3, .3, .3)",
                                offset: 0,
                            }),
                            style({
                                opacity: 1,
                                transform: "scale3d(1, 1, 1)",
                                offset: 0.5,
                            }),
                        ])
                    ),
                ],
                {
                    params: { timing: 1, delay: 0 },
                }
            )
        )
    ),
])

export const zoomInLeft = trigger("zoomInLeft", [
    transition("* => *", useAnimation(zoomInX("-1000px", "10px"))),
])
